import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Error from '../components/Error'
import PromiseHandler from '../services/api/PromiseHandler'
import Context from './Context'
import { BankIdSigningActions } from '../helpers/Constants'
import { isMobile, isAndroid, isIOS } from 'react-device-detect'

const GlobalState = ({ children, params }) => {
  const [url, setUrl] = useState(window.location.search)
  const [customer, setCustomer] = useState({})
  const [invoice, setInvoice] = useState({})
  const [organizationSettings, setOrganizationSettings] = useState({})
  const [customElementContent, setCustomElementContent] = useState({})
  const [isLoaded, setIsLoaded] = useState(false)
  const [error, setError] = useState(false)
  const [signingActionId, setSigningActionId] = useState(1)

  useEffect(() => {
    const promiseHandler = new PromiseHandler(params.customerId, params.ocr, params.preview)

    promiseHandler.execute().then((res) => {
      if (res) {
        setUrl(window.location.search)
        setCustomer(res[0])
        setInvoice(res[1])
        setCustomElementContent(res[2])
        setOrganizationSettings(res[3])
        setIsLoaded(true)
      }

      setSigningActionId((isMobile && (isIOS || isAndroid))
        ? BankIdSigningActions.MOBILE
        : BankIdSigningActions.QR_CODE
      )
    }).catch((error) => {
      setError(error)
      setIsLoaded(true)
    })
  }, [])

  function getStyle (organizationSetting) {
    return {
      background: {
        background: organizationSetting.backgroundColor
      },
      header: {
        background: organizationSetting.headerBackgroundColor
      },
      button: {
        background: organizationSetting.paymentButtonColor,
        border: organizationSetting.paymentButtonColor
      },
      link: {
        color: organizationSetting.linkColor
      },
      positionOfLogo: organizationSetting.positionOfLogo
    }
  }

  if (!isLoaded) {
    return null
  }

  if (error) {
    return <Error />
  }

  if (isLoaded) {
    return (
      <Context.Provider
        value={{
          url,
          customer,
          invoice,
          organizationSettings,
          customElementContent,
          style: getStyle(organizationSettings),
          signingActionId
        }}
      >
        {children}
      </Context.Provider>
    )
  }
}

GlobalState.propTypes = {
  children: PropTypes.element,
  params: PropTypes.object
}

export default GlobalState
